define(
    'viewmodels/secured/explorer/navigation/checkout/checkout',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "viewmodels/secured/explorer/navigation/menu",
        "services/BusyTracker",
        "i19n!i19n/strings"
    ],
    function (ctx, ViewModel, dataProvider, menu, BusyTracker, i19n) {

        var vm = new ViewModel({
            i19n: i19n,
            menu: menu,
            checkedOutDocumentsMenuItem: new menu.Item(true, 'checkedout'),
            checkoutCount: ko.observable(0)
        });

        vm.menu.items().push(vm.checkedOutDocumentsMenuItem);

        vm.checkedOutDocumentsMenuItem.isSelected.subscribe(function (newValue) {
            ctx.onNavFolder(null); //to hide results grid
        });

        vm.showMyDocumentsAction = ko.asyncCommand({
            canExecute: function () {
                return vm.checkedOutDocumentsMenuItem.isSelected();
            },
            execute: function (complete) {
                ctx.menu.currentItem().id = "checkedout-my";
                ctx.onNavMyCheckedOut(null);

                complete();
            }
        });
        vm.showAllDocumentsAction = ko.asyncCommand({
            canExecute: function () {
                return vm.checkedOutDocumentsMenuItem.isSelected();
            },
            execute: function (complete) {
                ctx.menu.currentItem().id = "checkedout-all";
                ctx.onNavAllCheckedOut(null);

                complete();
            }
        });

        vm.activate = function () {
            vm.updateChecoutCount();
        };

        vm.updateChecoutCount = function () {
            dataProvider.documents
            .getDocumentsCheckedOut()
            .done(function (data) {
                vm.checkoutCount(data.total);
            })
            .fail(function (e) {
                console.error(e);
            });
        };

        vm.eventBroker.on(vm, vm.config.events.explorer.navigation.checkoutCount, function () {
            vm.updateChecoutCount();
        });

        return vm;

    });
